import React, { useEffect, useState } from "react";
import { fetchData, postData } from "../../../apiService";
import { useHistory } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

// const planetDataStatic = [
//     { name: "Sun", position: "Leo", degree: "15° 30'", icon: "☀️" },
//     { name: "Moon", position: "Cancer", degree: "23° 18'", icon: "🌙" },
//     { name: "Mercury", position: "Virgo", degree: "5° 12'", icon: "☿️" },
//     { name: "Venus", position: "Libra", degree: "12° 44'", icon: "♀️" },
//     { name: "Mars", position: "Scorpio", degree: "8° 03'", icon: "♂️" },
//     { name: "Jupiter", position: "Taurus", degree: "1° 55'", icon: "♃" },
//     { name: "Saturn", position: "Pisces", degree: "18° 02'", icon: "♄" },
//     { name: "Rahu", position: "Aries", degree: "10° 40'", icon: "☊" },
//     { name: "Ketu", position: "Libra", degree: "10° 40'", icon: "☋" },
// ];

const PlanetViewPage = () => {
    const [user, setUser] = useState(null);
    const [planetData, setPlanetData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const history = useHistory();

    const userId = 1;

    const fetchtableData = async () => {
        try {
            const response = await fetchData("UserApi", `/LoggedUserData/${userId}`);
            if (response.responseCode === "1111") {
                setUser(response.response_data);
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };

    const handleSubmit = async () => {
        if (!user) return;

        setIsLoading(true);

        const formatDate = (dateString) => {
            const date = new Date(dateString);
            return date.toISOString().split("T")[0]; // "YYYY-MM-DD"
        };

        const CreateData = {
            companyId: 1,
            userId: 1,
            createdBy: 1,
            Date: formatDate(user.DateofBirth),
            Time: user.TimeoBirth,
            Latitude: 9.9816,
            Longitude: 76.2999,
        };

        try {
            const response = await postData("Ephemeris/Predict", CreateData); // ✅ Fixed here
            console.log(response.response_data);
            // setPlanetData(response.planets); // If response is actual planet data
            setPlanetData(response.response_data.planets); // ✅ Correct
            setSuccessMessage("Ephemeris Created successfully!");
            setErrorMessage("");
        } catch (error) {
            console.error("Ephemeris Plan Create error:", error);
            setErrorMessage("Failed to create Ephemeris.");
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(() => {
        fetchtableData();
    }, []);

    useEffect(() => {
        if (user) {
            handleSubmit(); // only submit after user is fetched
        }
    }, [user]);

    // Planet Icons
    const planetIcons = {
        "Sun": "☀️",
        "Moon": "🌙",
        "Mercury": "☿️",
        "Venus": "♀️",
        "Mars": "♂️",
        "Jupiter": "♃",
        "Saturn": "♄",
        "Uranus": "🔭",
        "Neptune": "🔱",
        "Pluto": "🪐",
        "Mean Node": "☊",
        "True Node": "☋"
    };

    return (
        <div className="min-h-screen bg-[#1e1e1e] text-white p-4 md:p-8">
            <h5 className="font-bold text-center mb-4 uppercase tracking-wider text-white">
                Planetary Positions
            </h5>

            {isLoading && (
                <div className="text-center text-yellow-400 font-mono mb-6">Loading...</div>
            )}
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
                {planetData && planetData.length > 0 && planetData.map((planet, index) => (
                    <div
                        key={index}
                        className="bg-[#2e2e2e] border border-gray-700 rounded-2xl shadow-md p-6 flex flex-col items-center transition hover:scale-105"
                        style={{ background: '#1e1e1e', borderRadius: '20px' }}
                    >
                        <div className="text-3xl mb-2">
                            {planetIcons[planet.planet] || "🪐"}
                        </div>
                        <div className="text-lg font-semibold text-green-300">{planet.planet}</div>
                        <div className="text-sm text-gray-300 mt-1">{planet.formattedLongitude}</div>
                    </div>
                ))}
            </div>

        </div>
    );
};

export default PlanetViewPage;
